import { z } from "zod";
import { TableAnalysisItemSchema } from "../readExcel/readExcel.schema";
export const TableAnalysisParamsSchema = z.object({
    uiDescription: z
        .string()
        .optional()
        .describe("Brief plain-English summary of the analysis intent."),
    tableAnalysis: z.array(TableAnalysisItemSchema).describe("Table-analysis operations."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { TableAnalysisParamsSchema as TableAnalysisToolParamsSchema };
